import * as React from 'react';
import * as withSideEffect from 'react-side-effect';

interface Props {
  excludeBundle?: boolean;
}

const CSSBundle: React.SFC<Props> = ({ children }) => (
  <React.Fragment>{children}</React.Fragment>
);

function reducePropsToState(propsList: Props[]) {
  const innermostProps = propsList[propsList.length - 1];

  return (innermostProps && innermostProps.excludeBundle) || false;
}

function handleStateChangeOnClient(excludeBundle: Props['excludeBundle']) {
  return excludeBundle;
}

export default withSideEffect(reducePropsToState, handleStateChangeOnClient)(
  CSSBundle,
);
